<template>
	<div>
		<div>
			<Button type="primary" @click="addWhiteLoginUser">添加</Button>
		</div>
		<div style="margin-top: 20px;">
			<Table size="small" :columns="columns" :data="data">
				<template slot-scope="{row, index}" slot="performance">
					<Input v-model="data[index].achievement" style="width: 100px" />
				</template>
				<template slot-scope="{row, index}" slot="door">
					<Input v-model="data[index].view_nums" style="width: 60px" />
				</template>
				<template slot-scope="{row, index}" slot="sign">
					<Input v-model="data[index].sign_nums" style="width: 60px" />
				</template>
			</Table>
		</div>
			<Modal v-model="modal" width="500" title="添加白名单">
				<Form :label-width="120">
					<FormItem label="员工">
						<Select v-model="whiteLoginUserForm.uid" filterable>
							<Option v-for="item in userList" :value="item.id" :key="item.id">
								{{item.name }}-[{{item.id}}]
							</Option>
						</Select>
					</FormItem>
				</Form>
				<div slot="footer">
					<Button type="primary" @click="save">提交</Button>
					<Button type="default" @click="modal = false">取消</Button>
				</div>
			</Modal>
	</div>
</template>

<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getWhiteLoginUserList,
		getAllUserList,
		saveWhiteLoginUser 
	} from "../../api/user";

	export default {
		name: "white_login_user",
		components: {},
		data() {
			return {
				modal: false,
				whiteLoginUserForm: {
					uid: '',
					shop_id: '',
					status: 0
				},
				columns: [{
						title: '员工姓名',
						key: 'name'
					},
					{
						title: '创建时间',
						key: 'created_at'
					},
				],
				data: [],
				userList:[],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.loadData();
			this.getList();
		},
		methods: {
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllUserList(that, data);
				that.userList = res.data.list;
			},			
			async getList() {
				let that = this;
				let data = {
				}
				data.token = this.token;
				let res = await getWhiteLoginUserList(that, data);
				this.data = res.data.list;
			},
			addWhiteLoginUser() {
				this.whiteLoginUserForm = {};
				this.modal = true;
			},
			save() {
				let that = this;
				that.throttle(async function() {
					let data = {
						whiteLoginUserForm: that.whiteLoginUserForm
					}
					data.token = this.token;
					let res = await saveWhiteLoginUser(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.getList();
						that.modal =false;
					}
				}, 500)
			}
		}
	}
</script>

<style scoped lang="less">
	.yl-flex {
		display: flex;
		justify-content: flex-end;
		padding-bottom: 0;
	}

	.add_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.add_title {
		margin: 0 10px;
		font-weight: bold;

	}

	.add_box {
		border: 1px solid #969696;
		padding: 10px;
	}

	/deep/ .ivu-table th {
	  background: #277dd3;
	  color: white;
	}
	/deep/ .ivu-table .table-blue-row td {
	  color: #ff6699;
	}
	/deep/ .ivu-table .table-yellow-row td {
	  color: #aaaa00;
	}
	
	/deep/ .ivu-table .table-black-row td {
	  color: black;
	}
</style>
